var React = require('react');

function AfInline (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_403_119)","key":0},React.createElement("path",{"d":"M13.53 0L5.09 12.398C3.98 14.028 2.177 15.6 0 15.767V16.148H9.38699C11.879 16.148 13.697 14.501 14.927 12.687L23.594 0H13.531H13.53Z","fill":"#FF0000"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_403_119"},React.createElement("rect",{"width":"24","height":"16","fill":"white"})))]);
}

AfInline.defaultProps = {"width":"24","height":"16","viewBox":"0 0 24 16","fill":"none"};

module.exports = AfInline;

AfInline.default = AfInline;
